export default {
  common: {
    back: 'Back',
    loading: 'Loading…',
    empty: 'No data',
    confirm: 'Confirm',
    cancel: 'Cancel',
    search: 'Search',
    submit: 'Submit',
    retry: 'Retry',
    downloading: 'Downloading…',
    downloadDone: 'Download complete',
    browserTipLine1: 'Please tap the top-right corner',
    browserTipLine2: 'and open in the default browser',
    workType: {
      video: 'Video',
      image: 'Image',
      audio: 'Music',
      pdf: 'PDF Portfolio',
      game: 'Game',
      bigImage: 'Portfolio',
      linkCard: 'Web Portfolio',
      openMaic: 'Visual Explanation',
      artBook: 'Picture Story',
      model3d: '3D Model',
    },
    share: {
      titleVideo: 'Just found an amazing video, sharing it with you!',
      titleImage: 'Found a super creative image, sharing it now!',
      titleBigImage: 'Found an awesome original portfolio, sharing it!',
      titlePdf: '{title} PDF Portfolio',
      titleLinkCard: '{title} Web Portfolio',
      titleOpenMaic: '{title}',
      titleArtBook: '{title} Picture Story',
      titleAudio: 'Found a beautiful piece of music, sharing it!',
      titleText: 'Found a thought-provoking piece of writing, sharing it!',
      titleGame: 'New game "{title}" is live — come check it out!',
      titleModel3d: 'Found a creative 3D model, sharing it!',
      titleDefault: 'Found an amazing collection of creative works, sharing it!',
      descVideo: 'Original video, full of creativity{suffix}',
      descImage: 'Such a creative original image — come take a look!',
      descBigImage: 'From inspiration to execution — explore the full creative journey.',
      descAudio: 'Listen to a brand-new musical creation～{suffix}',
      descGame: "A wildly imaginative original game — you'll regret not playing it!",
      descOpenMaic: 'I created a visual explanation in MiaoBi — come see it!',
      descArtBook: 'A touching original picture story — come read it！',
      descTextEmpty: 'Shared original written content — come enjoy it!',
      descDefault: 'A collection of amazing works from multiple students — come enjoy!',
      descGeneric: 'Amazing original work — come take a look!',
    },
    duration: {
      seconds: '{s}s',
      minSec: '{m}m {s}s',
      hourMinSec: '{h}h {m}m {s}s',
      prefix: ' Duration: {duration}',
    },
  },
  help: {
    title: 'Help Center',
    subtitle: 'MiaoBi Help Center — usage guides and FAQs at your fingertips.',
    welcome: 'Hi, welcome!',
    searchPlaceholder: 'Search for questions',
    guessAsk: 'You might also ask',
    relatedCount: '{count} related results',
    noResult: 'No related questions found',
    detail: { title: 'Question Detail' },
    list: { title: 'Question List' },
  },
  detail: {
    authorLabel: 'Author: ',
    noTextContent: 'No content available',
    unknownCannotDisplay: 'Unable to display this work',
    messageIdLabel: 'Message ID: ',
    unknownRetryHint: 'Please try again later or wait for the server to complete the resource.',
    unsupportedType: 'Unsupported work type',
    typeLabel: 'type: ',
    pageTitleFallback: 'Work Detail',
    downloadFileNameFallback: 'work',
  },
  workList: {
    loading: 'Loading…',
    empty: 'No works available',
    pageTitleDefault: 'Work List',
    multiShareTitle: 'Found an amazing collection of creative works, sharing it!',
    multiShareDesc: 'A shared collection featuring works from multiple students — come enjoy!',
    authorFallback: 'Student',
    unknownWorkTitle: 'Work pending completion',
    unknownWorkText: 'Details to be completed by server',
    errorMissingCode: 'Missing work code (code)',
    errorLoadFailed: 'Load failed, please try again',
    downloadFileNameFallback: 'work',
  },
  download: {
    pageHeader: '{courseName} Work Download',
    studentUnit: ' students',
    worksUnit: ' works',
    downloadButton: 'Download Works',
    progressTitle: 'Download Progress',
    completeTitle: 'Download Complete',
    completeTip: 'Successfully downloaded {success}/{total} files',
    typeVideo: 'Video',
    typeImage: 'Image',
    typePortfolio: 'Portfolio',
    typeEncyclopedia: 'Encyclopedia',
    typePictureBook: 'Picture Book',
    typeMusic: 'Music',
    typePortfolioPdf: 'Portfolio-PDF',
    typePortfolioWeb: 'Portfolio-Web',
    typeGame: 'Game',
    typeAiBook: 'AI Picture Book',
    typeOpenMaic: 'Visual Explanation',
    typeVectorImage: 'Vector Image',
    typeImage2dTo3d: '2D to 3D Image',
    typeUnknown: 'Unknown',
    fileTypeModel: 'Model',
    fileTypePreview: 'Preview',
  },
  pdfPortfolio: {
    loading: 'Loading...',
    loadError: 'PDF failed to load, please retry',
    downloadButton: 'Download PDF',
    pageTitleFallback: 'PDF Portfolio',
    shareTitleFallback: 'PDF Portfolio',
    shareDesc: 'Amazing original work — come take a look!',
  },
  musicIsolate: {
    separating: 'Separating tracks…',
    originalTrack: 'Original',
    separationResult: 'Separation Result',
    startSeparation: 'Start Track Separation',
    restartSeparation: 'Redo Track Separation',
  },
  modelViewer3d: {
    back: 'Back',
    loading: 'Loading model…',
    loadError: 'Model failed to load, please check the link or network',
    pageTitleFallback: '3D Model',
    shareDesc: 'Amazing original work — come take a look!',
  },
  pictureBook: {
    pageTitleFallback: 'Picture Book',
    titleSuffixPortfolio: 'Web Portfolio',
    titleSuffixBook: 'Picture Story',
    shareDescPortfolio: 'Amazing original work — come take a look!',
    shareDescBook: 'A touching original picture story — come read it!',
    portfolioWorkName: 'Work {n}',
    pageName: 'Page {n}',
  },
  lessonInfo: {
    titleArt: 'AI Art General Course',
    titleMagic: 'AI Magic Painting Course',
    titleIp: 'AI Super IP Course',
    titleCourse: 'AI Creative Course',
    titleDesign: 'AI Art Design Course',
    titleArtDesign: 'AI Art Class',
    titleFallback: 'Course Detail',
  },
  home: {
    title: 'Home',
  },
};
